module.exports = __webpack_public_path__ + "images/logo7f9c3826befd48319756dec3514b01b7.png";